import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'form-input-number',
  template: `
    <div class="form-group">
      <label class="col-form-label font-weight-bold">{{label}}</label>
      <input type="text" class="form-control" 
             [class.is-invalid]="control.invalid && control.dirty"
             [placeholder]="placeholder" 
             [formControl]="control">
      <div *ngIf="control.invalid && control.dirty" class="text-danger-form">{{errorMsg ? errorMsg : 'campoObbligatorio' | translate}}</div>
    </div>
  `,
})
export class FormInputNumberComponent {

  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() errorMsg: string;

}
